import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateProject = async (projectCreationData, assignments) => {
  const parentId = projectCreationData.parent;
  const apiPath = `projects/${parentId}/create-new-project`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { projectCreationData, assignments },
  });

  const response = await axios(signedRequest);

  return response.data;
};
